export const initialState = {
    loading: false
}

export const FETCH_LOCATIONGROUP_BEGIN = "FETCH_LOCATIONGROUP_BEGIN";
export const FETCH_LOCATIONGROUP_SUCCESS = "FETCH_LOCATIONGROUP_SUCCESS";
export const FETCH_LOCATIONGROUP_FAILURE = "FETCH_LOCATIONGROUP_FAILURE";
